import type { Theme } from '@mui/material/styles';
import { Outlet } from '@tanstack/react-router';

import { Box } from '@src/components';
import { useAuthentication, useSidebar } from '@src/context/hooks';
import pallete from '@src/themes/palette';


const StyleSheet = {
  main: ({ isCollapsed }: { isCollapsed: boolean }) => ({
    flexGrow: 1,
    marginTop: (t: Theme) => `${t.layout.header.height}px`,
    height: (t: Theme) => `calc(100% - ${t.layout.header.height}px)`,
    width: (t: Theme) =>
      `calc(100% - ${isCollapsed ? t.layout.sidebar.minWidth : t.layout.sidebar.maxWidth}px)`,
    backgroundColor: 'layout.main.light',
    overflow: 'auto',
    minHeight: '100vh',
    padding: '24px',
    position: 'relative',
  }),
  loginAsNotification: {
    position: 'absolute',
    top: '10px',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: pallete.red[500],
    padding: '0 16px',
    opacity: 0.8,
  },
};

export default function Main() {
  const sidebar = useSidebar();
  const { user, credentials } = useAuthentication();
  const loginAs = credentials?.loginAs ?? false;
  if (!sidebar) {
    return null;
  }
  const { isCollapsed } = sidebar;
  return (
    <Box sx={StyleSheet.main({ isCollapsed })} component="main">
      {loginAs && (
        <Box sx={StyleSheet.loginAsNotification}>
          Login as {user?.name}
        </Box>
      )}
      <Outlet />
    </Box>
  );
}
